import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/services/auth/authentication.service';

@Component({
  standalone: false,
  selector: 'app-external-redirect',
  template: '<div class="external-redirect-message">Redirecting...</div>',
})
export class ExternalRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.authService.loginWithAnalyticsToken(token).subscribe({
        next: () => this.leave('/dashboard'),
        error: () => {
          // The analytics token couldn't be exchanged for a session; signing in normally is the way on.
          this.leave('/login');
        }
      });
    } else {
      this.leave('/login');
    }
  }

  /**
   * Moves on in place of this page, so the URL carrying the sign-in token is not left in the
   * browser's history.
   */
  private leave(path: string): void {
    this.router.navigate([path], { replaceUrl: true });
  }
}
